<template>

  <div id="right-panel" class="right-panel fContainer">

    <SellHeader></SellHeader>


    <div class="content mt-3 fColumn">
      <div class="animated fadeIn fColumn">
        <AlertInPage :type="AlertInPage.type" :msg="AlertInPage.msg" :delay="AlertInPage.delay"/>
        <form action="/" method="post" id="form" class="userForm ajaxForm     fColumn">
          <div class="card     fColumn ">
            <div class="card-header     fHead">
              <strong>{{$t('businesspartner.title')}}</strong>
              <div class="float-right">
                <a data-template="businesspartner" data-clear="true" data-clearTarget="true" class="linkToTemplate" href="#">
                  <button type="button" class="btn btn-primary btn-smX " v-on:click="newBusinessPartner()">
                    <i class="fa fa-star"></i> {{$t('businesspartner.new')}}
                  </button>
                </a>
              </div>
            </div>
            <div class="    fContent">
              <div class="card-body card-block ">
                <form action="" method="post" class="">

                  <div class="hiddenSzb">
                    <input type="text" name="del">
                    <input type="text" id="id" name="id" class="form-control id"
                           value="">
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="businesspartnername" class=" form-control-label">{{ $t('businesspartner.businesspartnername') }} ({{ $t('validator.required') }})</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText id="businesspartnername" name="data.businesspartnername" v-model="data.businesspartnername" v-validate="'required'" hasToKeyboard="auto" value=""
                                 :title="$t('businesspartner.businesspartnername')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.businesspartnername')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>


                  <!--                                    invoiceUseType
                                                      invoiceUseType

                                                      <div class="row form-group">
                                                          <div class="col col-md-3"><label for="taxnumber" class=" form-control-label">{{ $t('businesspartner.taxnumber') }} ({{ $t('validator.required') }})</label></div>
                                                          <div class="col-12 col-md-9">
                                                              <InputText id="taxnumber" name="data.taxnumber" v-model="data.taxnumber" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('businesspartner.taxnumber')"
                                                                         placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.taxnumber')"/>
                                                              <small class="form-text text-muted"></small>
                                                          </div>
                                                      </div>
                  -->
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="taxnumber" class=" form-control-label">{{ $t('businesspartner.taxnumber')
                      }} {{ (isResellerSettings) ? "(" + $t('validator.required') + ")" : ''
                      }} <span
                        class="validatorrequired"></span></label></div>
                    <div class="col-12 col-md-9">
                      <table class="w100">
                        <tr>
                          <td class="w0">
                            <template v-if="hasnav===true&& (invoiceUseType==='1'||invoiceUseType==='2')">
                              <div class="input-group topminus2px">
                                <div class="btn btn-primary" v-on:click="getQueryTaxpayer"><i class="fa fa-eye-slash"></i></div>
                              </div>
                            </template>
                          </td>
                          <td class="w100">
                            <InputText
                              id="taxnumber" name="data.taxnumber" v-model="data.taxnumber" v-validate="(isResellerSettings)?'required':''" hasToKeyboard="auto" value=""
                              :title="$t('businesspartner.taxnumber')"
                              placeholder="..." dataLayout="nn" className="form-control mandatory w100X" class="w100" :hasError="errors.has('data.taxnumber')"/>
                            <small class="form-text text-muted"></small>
                          </td>
                        </tr>
                      </table>
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="taxnumbercountrygroup" class=" form-control-label">{{ $t('businesspartner.taxnumbercountrygroup') }} </label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="taxnumbercountrygroup" name="data.taxnumbercountrygroup" v-model="data.taxnumbercountrygroup" v-validate="''" hasToKeyboard="auto" value=""
                                 :title="$t('businesspartner.taxnumbercountrygroup')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.taxnumbercountrygroup')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="taxnumberother" class=" form-control-label">{{ $t('businesspartner.taxnumberother') }} </label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="taxnumberother" name="data.taxnumberother" v-model="data.taxnumberother" v-validate="''" hasToKeyboard="auto" value=""
                                 :title="$t('businesspartner.taxnumberother')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.taxnumberother')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="registrationnumber" class=" form-control-label">{{ $t('businesspartner.registrationnumber') }} </label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="registrationnumber" name="data.registrationnumber" v-model="data.registrationnumber" v-validate="''" hasToKeyboard="auto" value=""
                                 :title="$t('businesspartner.registrationnumber')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.registrationnumber')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col col-md-3"><label for="bank_account" class=" form-control-label">{{ $t('businesspartner.bank_account') }} </label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="bank_account" name="data.bank_account" v-model="data.bank_account" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.bank_account')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.bank_account')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>


                  <div class="row form-group">
                    <div class="col col-md-3"><label for="zip" class=" form-control-label">{{ $t('businesspartner.zip') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="zip" name="data.zip" v-model="data.zip" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('businesspartner.zip')"
                                 placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.zip')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="city" class=" form-control-label">{{ $t('businesspartner.city') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="city" name="data.city" v-model="data.city" v-validate="'required'" hasToKeyboard="auto" value="" :title="$t('businesspartner.city')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.city')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="public_space" class=" form-control-label">{{ $t('businesspartner.public_space') }} ({{ $t('validator.required') }})</label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="public_space" name="data.public_space" v-model="data.public_space" v-validate="'required'" hasToKeyboard="auto" value=""
                                 :title="$t('businesspartner.public_space')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.public_space')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="nature_of_public_space" class=" form-control-label">{{ $t('businesspartner.nature_of_public_space') }} ({{ $t('validator.required')
                      }})</label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="nature_of_public_space" name="data.nature_of_public_space" v-model="data.nature_of_public_space" v-validate="'required'" hasToKeyboard="auto" value=""
                                 :title="$t('businesspartner.nature_of_public_space')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.nature_of_public_space')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="house_number" class=" form-control-label">{{ $t('businesspartner.house_number') }}</label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="house_number" name="data.house_number" v-model="data.house_number" v-validate="" hasToKeyboard="auto" value="" :title="$t('businesspartner.house_number')"
                                 placeholder="..." dataLayout="nn" className="form-control mandatory" :hasError="errors.has('data.house_number')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="building" class=" form-control-label">{{ $t('businesspartner.building') }}</label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="building" name="data.building" v-model="data.building" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.building')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.building')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="staircase" class=" form-control-label">{{ $t('businesspartner.staircase') }}</label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="staircase" name="data.staircase" v-model="data.staircase" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.staircase')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.staircase')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="floor" class=" form-control-label">{{ $t('businesspartner.floor') }}</label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="floor" name="data.floor" v-model="data.floor" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.floor')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.floor')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="door" class=" form-control-label">{{ $t('businesspartner.door') }}</label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="door" name="data.door" v-model="data.door" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.door')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.door')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="county" class=" form-control-label">{{ $t('businesspartner.county') }}</label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="county" name="data.county" v-model="data.county" v-validate="" hasToKeyboard="auto" value="" :title="$t('businesspartner.county')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.county')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="country" class=" form-control-label">{{ $t('businesspartner.country') }}</label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="country" name="data.country" v-model="data.country" v-validate="" hasToKeyboard="auto" value="" :title="$t('businesspartner.country')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.country')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="email_def" class=" form-control-label">{{ $t('businesspartner.email_def') }} </label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="email_def" name="data.email_def" v-model="data.email_def" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.email_def')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.email_def')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-md-3"><label for="phone_def" class=" form-control-label">{{ $t('businesspartner.phone_def') }} </label></div>
                    <div class="col-12 col-md-9">
                      <InputText id="phone_def" name="data.phone_def" v-model="data.phone_def" v-validate="''" hasToKeyboard="auto" value="" :title="$t('businesspartner.phone_def')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.phone_def')"/>
                      <small class="form-text text-muted"></small>
                    </div>
                  </div>

                  <div class="row form-group">
                    <div class="col col-3 extensionLineX">
                      <label for="discount" class=" form-control-label">{{$t('businesspartner.discount')}}</label>
                    </div>
                    <div class="col-12 col-md-9">
                      <InputText id="discount" name="data.discount" v-model="data.discount" v-validate="'required|integer|between:0,100'" hasToKeyboard="auto" value=""
                                 :title="$t('businesspartner.discount')"
                                 placeholder="..." dataLayout="tn" className="form-control mandatory" :hasError="errors.has('data.discount')"/>
                      <small class="unit form-text text-muted d-none"></small>
                    </div>
                  </div>


                </form>
              </div>
            </div>


            <div class="card-footer text-center fFix">
              <button v-on:click="save()" type="button" class="btn btn-success btn-lg">
                <i class="fa fa-dot-circle-o"></i> {{$t('businesspartner.save')}}
              </button>
            </div>
          </div>
        </form>
      </div><!-- .animated -->
      <div class="h40p"></div>
    </div><!-- .content -->
  </div>

</template>


<script>
  import LngChooser from '@/components/LngChooser.vue';
  import AlertInPage from '@/components/AlertInPage.vue';
  import Helper from '@/helper/Helper';
  import SellHeader from "../components/SellHeader";
  import InputText from '@/components/InputText.vue';
  import i18n from '@/i18n';
  //    import SyncHandler from '@/sync/syncHandler';
//  const request = require('request');
  const https = require('https');
  //    const log = require('electron-log');
  import Api from '@/api/Api';

  export default {
    name: 'BusinessPartner',
    data() {
      return {
        data: {
          "id": "",
          "businesspartnername": "",
//          "dt": "",
          "taxnumber": "",
          "taxnumbercountrygroup": "",
          "taxnumberother": "",
          "registrationnumber": "",
          "bank_account": "",
          "zip": "",
          "public_space": "",
          "nature_of_public_space": "",
          "house_number": "",
          "building": "",
          "staircase": "",
          "floor": "",
          "door": "",
          "county": "",
          "city": "",
          "country": "",
          "email_def": "",
          "phone_def": "",
          "discount": "0",
        }
        , dataDefault: { // need for change without save
          "id": "",
          "businesspartnername": "",
//          "dt": "",
          "taxnumber": "",
          "taxnumbercountrygroup": "",
          "taxnumberother": "",
          "registrationnumber": "",
          "bank_account": "",
          "zip": "",
          "public_space": "",
          "nature_of_public_space": "",
          "house_number": "",
          "building": "",
          "staircase": "",
          "floor": "",
          "door": "",
          "county": "",
          "city": "",
          "country": "",
          "email_def": "",
          "phone_def": "",
          "discount": "0",
        }

        , lang: "en"
        , isResellerSettings: false
        , hasnav: true
        , invoiceUseType: "2"
        , AlertInPage: {
          type: "", // primary secondary success danger warning info light dark
          msg: "",
          delay: 5000,
        }
      };
    },
    props: {
      id: String,
    },
    watch: {
      'localStorage.lang': function (newLang, oldLang) {
        const modul = this;
        modul.lang = newLang;
      }
      , 'data.sid': function (newdata, olddata) {
        const modul = this;
        if (modul.timer) {
          clearTimeout(modul.timer);
        }
        modul.timer = setTimeout(function () {
          if (newdata && newdata !== olddata) {
            modul.data.sid = modul.data.sid.replace(/ö/g, '0');
          }
        }, 300);
      },
      '$route.params': function (newdata, olddata) {
        const modul = this;
        if (this.$route.params.id) {
          modul.id = newdata;
          modul.getBusinessPartnerById(function (err, res) {
            if (res && res[0]) {
              console.log(res[0]);
              const copieddata = res[0];
              copieddata.discount = "" + (copieddata.discount);
              modul.data = copieddata;
            }
          }, newdata);
        } else {
          modul.id = void 0;
        }
      }

    },
    mounted() {
      const modul = this;
      console.log(this.$route.name + " mounded");
      modul.roles = [3, 4, 5, 6, 7, 8, 9, 10];
      const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.user_role) ? modul.$store.state.user.user_role : 0;
      if (!Helper.checkRoles(modul.roles, role)) {
        modul.$router.push({name: "login"})
      }
      if (modul.$route.params.id) {

        modul.getBusinessPartnerById(function (err, res) {
          if (res) { //  && res[0]
//                    console.log(res[0]);
            const copieddata = res;
            copieddata.discount = "" + (copieddata.discount);
            modul.data = copieddata;
          }
        }, modul.$route.params.id);
      }

      modul.$eventBus.$on('globalSetLang', this.globalSetLangEventHandler);
      modul.$eventBus.$on('globalReadBusinessPartnerSid', this.globalReadBusinessPartnerSidEventHandler);

      if (localStorage.getItem("invoiceUseType")) {
        modul.invoiceUseType = localStorage.getItem("invoiceUseType");
      } else {
        modul.invoiceUseType = "2";
        localStorage.setItem("invoiceUseType", modul.invoiceUseType);
      }

    },
    beforeDestroy() {
      const modul = this;
      modul.$eventBus.$off('globalSetLang');
      modul.$eventBus.$off('globalReadBusinessPartnerSid');
    },
    methods: {
      globalReadBusinessPartnerSidEventHandler(sid){
        const modul = this;
        modul.data.sid = sid;
      },
      newBusinessPartner(){
        const modul = this;
        modul.data = Object.assign({}, modul.dataDefault);
      },
      globalSetLangEventHandler(lang){
        const modul = this;
        modul.lang = lang;
      },
      save(){
        const modul = this;
        console.log("save");
        modul.$validator.validateAll().then((result) => {
          console.log("validate res:");
          console.log(result);
          if (result) {
            console.log("result true");
            const data = Helper.makeFilteredObjectByKeys(modul.data, Object.keys(modul.dataDefault));
            this.getBusinessPartnerByTaxnumber(function (err, res) {
              if (!data.id) {
                delete(data.id);
              }
              delete data.del;
              console.log("data:");
              console.log(data);
              data['sync_mdt'] = Helper.getNewUTCDateTime(); //new Date(); //model.createDateAsUTC(new Date());
              if (res && res.length > 0 && ( (!data.id) || (data.id && Number(data.id) !== Number(res[0].id)) )) {
                console.log("van ilyen partner már:");
                modul.AlertInPage.msg = "businesspartner.texterrortaxnumber";
                modul.AlertInPage.type = "danger";
                setTimeout(function (e) {
                  modul.AlertInPage.msg = "";
                }, Number(5000));
              } else {
                console.log("nics ilyen partner:");
                if (data.id) {
                  console.log("van id, tehát módosítás:");
                  const cb = function (err, res) {
                    console.log("létező partner, módosítás sikeres:");
                    modul.AlertInPage.msg = "businesspartner.textsucces";
                    modul.AlertInPage.type = "success";
                    setTimeout(function (e) {
                      console.log("ugrás - sellinone");
                      modul.AlertInPage.msg = "";
                      modul.$router.push({name: "sellinone"})
                    }, Number(1000));
                    setTimeout(function () {
                      console.log("sync doBusinessPartner:");
//                                            SyncHandler.handle({job: 'doBusinessPartner'});
                    }, 1000);
                  };
                  Api.saveBusinessPartner({data: data}).then(function (e) {
                    if (e && e.result === true) {
                      console.log(e)
                      cb(null, e.data);
                    }
                  }, function (err) {
                    console.log(err)
                    cb(err, null);
                  });

//                                    window.db.update(
//                                        function (err, res) {
//                                            cb(err, window.db.convertResToArray(err, res))
//                                        }
//                                        , "businesspartner", data, "id=" + Number(data.id));
                } else {
                  console.log("nincs id, tehát új partner:");
                  const cb = function (err, res) {
                    console.log("új partner, beszúrás sikeres:");
                    modul.AlertInPage.msg = "businesspartner.textsucces";
                    modul.AlertInPage.type = "success";
                    setTimeout(function (e) {
                      modul.AlertInPage.msg = "";
                      modul.$router.push({name: "sellinone"})
                    }, Number(1000));
                    setTimeout(function () {
                      console.log("sync doBusinessPartner:");
//                                            SyncHandler.handle({job: 'doBusinessPartner'});
                    }, 1000);
                  };
                  // Ha nincs ilyen businesspartner
                  data['create_dt'] = Helper.getNewUTCDateTime();

                  Api.saveBusinessPartner({data: data}).then(function (e) {
                    if (e && e.result === true) {
                      console.log(e)
                      cb(null, e.data);
                    }
                  }, function (err) {
                    console.log(err)
                    cb(err, null);
                  });

//                                    window.db.pinsert(
//                                        function (err, res) {
//                                            cb(err, window.db.convertResToArray(err, res))
//                                        }
//                                        , "businesspartner", data);
                }
              }
            }, data.taxnumber);
          } else {
            // form validate error
            modul.AlertInPage.msg = "global.saveError";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(5000));
          }
        }, (result) => {
          // form validate error
          modul.AlertInPage.msg = "global.saveError";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
        });
      },
//      ggg: function (e) {
//        const modul = this;
//
//        const arrTexnumber = modul.data.taxnumber.split("-");
//        const taxnumber = arrTexnumber[0];
//        if (taxnumber && taxnumber.length !== 8) {
//
//          modul.AlertInPage.msg = "businesspartner.taxPayerErrorFormat";
//          modul.AlertInPage.type = "danger";
//          setTimeout(function (e) {
//            modul.AlertInPage.msg = "";
//          }, Number(5000));
//          return
//        }
//        fetch('http://localhost:3000/api/invoice/getQueryTaxpayer', {
//          method: 'POST', // or 'PUT'
//          headers: {
//            'Content-Type': 'application/json',
//          },
//          body: JSON.stringify({taxnumber: taxnumber}),
//        })
//          .then(response => response.json())
//          .then(data => {
//            console.log('Success:', data);
//          })
//          .catch((error) => {
//            console.error('Error:', error);
//          });
//      },
      // http://localhost:3000/api/invoice/getQueryTaxpayer
      getQueryTaxpayer: function (e) {
        const modul = this;
        if (!modul.data.taxnumber) {
          modul.AlertInPage.msg = "businesspartner.taxPayerErrorEmpty";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }
        const arrTexnumber = modul.data.taxnumber.split("-");
        const taxnumber = arrTexnumber[0];
        if (taxnumber && taxnumber.length !== 8) {

          modul.AlertInPage.msg = "businesspartner.taxPayerErrorFormat";
          modul.AlertInPage.type = "danger";
          setTimeout(function (e) {
            modul.AlertInPage.msg = "";
          }, Number(5000));
          return
        }

        const baseUrl = 'http://localhost:';
        const port = 3000;
        const postUrl = '/api/invoice/getQueryTaxpayer';
        const fullPost = {taxnumber: taxnumber};


        fetch(baseUrl + port + postUrl, {
          method: 'POST', // or 'PUT'
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(fullPost),
        })
          .then(response => response.json())
          .then(data => {
            console.log('Success:', data);
            const body = data;

            if (body && body.result && body.result.data) {
              const data = Object.assign({}, body.result.data);
              const moduldata = Object.assign({}, modul.data);
              moduldata.building = Helper.String(data.building); //
              moduldata.businesspartnername = Helper.String(data.businesspartnername); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.businesspartnernameany = Helper.String(data.businesspartnernameany); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
              moduldata.city = Helper.String(data.city); // CSETÉNY"
              moduldata.county = Helper.String(data.county); //
              moduldata.door = Helper.String(data.door); //
              moduldata.email_def = Helper.String(data.email_def); //
              moduldata.floor = Helper.String(data.floor); //
              moduldata.house_number = Helper.String(data.house_number); // 39"
//                            moduldata.id = Helper.String(data.id) ; //
              moduldata.lot_number = Helper.String(data.lot_number); //
              moduldata.nature_of_public_space = Helper.String(data.nature_of_public_space); // UTCA"
              moduldata.phone_def = Helper.String(data.phone_def); //
              moduldata.public_space = Helper.String(data.public_space); // RÁKÓCZI FERENC"
              moduldata.staircase = Helper.String(data.staircase); //
              moduldata.zip = Helper.String(data.zip); // 8417"
              modul.data = moduldata;
            }
            if (body && body.result) {
              modul.AlertInPage.msg = "sell2.alertSuccess";
              modul.AlertInPage.type = "success";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(8000));
            } else {
              modul.AlertInPage.msg = "sell2.alertUnSuccess";
              modul.AlertInPage.type = "danger";
              setTimeout(function (e) {
                modul.AlertInPage.msg = "";
              }, Number(10000));
            }


          })
          .catch((error) => {
            console.error('Error:', error);

            console.log(error);
            modul.AlertInPage.msg = "sell2.alertUnSuccessHttp";
            modul.AlertInPage.type = "danger";
            setTimeout(function (e) {
              modul.AlertInPage.msg = "";
            }, Number(10000));

          });




//        const baseUrl = 'http://localhost:';
//        const port = 3000;
//        const postUrl = '/api/invoice/getQueryTaxpayer';
//        const fullPost = {taxnumber: taxnumber};
//        request.get({
//          url: baseUrl + port + postUrl,
//          form: fullPost,
//          headers: {
//            "cache-control": "no-cache",
//            "content-type": "application/json",
//          },
//          json: true,
//        }, function (error, response, body) {
//          const res = {error: error, response: response, body: body};
//          const modul2 = modul;
//          if (response && response.statusCode && response.statusCode === 200) {
//            console.log("res:");
//            console.log(res);
//            console.log("body:");
//            console.log(body);
//            if (body && body.result && body.result.data) {
//              const data = Object.assign({}, body.result.data);
//              const moduldata = Object.assign({}, modul.data);
//              moduldata.building = Helper.String(data.building); //
//              moduldata.businesspartnername = Helper.String(data.businesspartnername); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
//              moduldata.businesspartnernameany = Helper.String(data.businesspartnernameany); // KISKUTYA" SZOLGÁLTATÓ KORLÁTOLT FELELŐSSÉGŰ TÁRSASÁG"
//              moduldata.city = Helper.String(data.city); // CSETÉNY"
//              moduldata.county = Helper.String(data.county); //
//              moduldata.door = Helper.String(data.door); //
//              moduldata.email_def = Helper.String(data.email_def); //
//              moduldata.floor = Helper.String(data.floor); //
//              moduldata.house_number = Helper.String(data.house_number); // 39"
////                            moduldata.id = Helper.String(data.id) ; //
//              moduldata.lot_number = Helper.String(data.lot_number); //
//              moduldata.nature_of_public_space = Helper.String(data.nature_of_public_space); // UTCA"
//              moduldata.phone_def = Helper.String(data.phone_def); //
//              moduldata.public_space = Helper.String(data.public_space); // RÁKÓCZI FERENC"
//              moduldata.staircase = Helper.String(data.staircase); //
//              moduldata.zip = Helper.String(data.zip); // 8417"
//              modul.data = moduldata;
//            }
//            if (body && body.result) {
//              modul.AlertInPage.msg = "sell2.alertSuccess";
//              modul.AlertInPage.type = "success";
//              setTimeout(function (e) {
//                modul.AlertInPage.msg = "";
//              }, Number(8000));
//            } else {
//              modul.AlertInPage.msg = "sell2.alertUnSuccess";
//              modul.AlertInPage.type = "danger";
//              setTimeout(function (e) {
//                modul.AlertInPage.msg = "";
//              }, Number(10000));
//            }
//
//          } else if (response && response.statusCode && response.statusCode >= 400) {
//            console.log(error);
//            modul.AlertInPage.msg = "sell2.alertUnSuccessHttpCode";
//            modul.AlertInPage.msgPost = "(" + response.statusCode + ")";
//            modul.AlertInPage.type = "danger";
//            setTimeout(function (e) {
//              modul.AlertInPage.msg = "";
//              modul.AlertInPage.msgPost = "";
//            }, Number(10000));
//          }
//          if (error) {
//            console.log(error);
//            modul.AlertInPage.msg = "sell2.alertUnSuccessHttp";
//            modul.AlertInPage.type = "danger";
//            setTimeout(function (e) {
//              modul.AlertInPage.msg = "";
//            }, Number(10000));
//          }
//        })
      },
      getBusinessPartnerByTaxnumber: function (cb, taxnumber) {
        Api.getBusinessPartner(taxnumber).then(function (e) {
          if (e && e.result === true) {
            console.log(e)
            cb(null, e.data);
          }
        }, function (err) {
          console.log(err)
          cb(err, null);
        });
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "businesspartner", "*", "taxnumber=" + window.db.quote(taxnumber) + " AND (`deleted` = 0 OR `deleted` = '0')");
      },
//            getBusinessPartnerBySid: function (cb, sid) {
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "businesspartner", "*", "sid=" + window.db.quote(sid) + " AND (`deleted` = 0 OR `deleted` = '0')");
//            },
      getBusinessPartnerById: function (cb, id) {
        Api.getBusinessPartner(id).then(function (e) {
          if (e && e.result === true) {
            console.log(e)
            cb(null, e.data);
          }
        }, function (err) {
          console.log(err)
          cb(err, null);
        });
//                window.db.select(
//                    function (err, res) {
//                        cb(err, window.db.convertResToArray(err, res))
//                    }
//                    , "businesspartner", "*", "`id` = " + Number(id) + ""); //  AND (`deleted` = 0 OR `deleted` = '0') // " OR `id` = " + window.db.quote(id) +
      },
    },
    components: {
      SellHeader,
      InputText,
      LngChooser,
      AlertInPage,
    },
  };
</script>

